(() => {
  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const hideLegacyHeroPrompt = () => {
    const productInfo = document.querySelector('product-info');
    if (!productInfo) return;

    productInfo.querySelectorAll('a, button, span, p, div').forEach((element) => {
      if (element.children.length > 0 || normalize(element.textContent) !== 'write a review') return;
      if (element.closest('.jdgm-widget, [class*="jdgm"]')) return;

      let target = element;
      while (
        target.parentElement &&
        target.parentElement !== productInfo &&
        normalize(target.parentElement.textContent) === 'write a review'
      ) {
        target = target.parentElement;
      }
      target.hidden = true;
      target.style.setProperty('display', 'none', 'important');
    });
  };

  const hideLegacyEmptyReviewBox = () => {
    document.querySelectorAll('body *').forEach((element) => {
      if (element.children.length > 0) return;
      const text = normalize(element.textContent);
      if (text !== 'be the first to review this item' && text !== 'customer reviews') return;

      let target = element;
      for (let depth = 0; depth < 9 && target.parentElement; depth += 1) {
        target = target.parentElement;
        const containerText = normalize(target.textContent);
        const isLegacyBox =
          containerText.includes('customer reviews') &&
          containerText.includes('be the first to review this item') &&
          containerText.includes('write a review');

        if (isLegacyBox) {
          target.hidden = true;
          target.style.setProperty('display', 'none', 'important');
          break;
        }
        if (target === document.body) break;
      }
    });
  };

  const cleanLegacyReviews = () => {
    hideLegacyHeroPrompt();
    hideLegacyEmptyReviewBox();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanLegacyReviews, { once: true });
  } else {
    cleanLegacyReviews();
  }

  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      cleanLegacyReviews();
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 15000);
})();
